(function() {
  const MOBILE_MAX_WIDTH = 749;
  const MOBILE_VIEWPORT_THRESHOLD = 0.6;
  const state = new WeakMap();
  let mobileObserver = null;

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_MAX_WIDTH;
  }

  function playVideo(video) {
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function() {});
    }
  }

  function ensureMobileObserver() {
    if (mobileObserver) return mobileObserver;

    mobileObserver = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          const video = entry.target;
          const videoState = state.get(video);
          if (!videoState || !isMobileViewport()) return;

          if (entry.isIntersecting) {
            if (!videoState.manuallyPaused) {
              playVideo(video);
            }
          } else {
            video.pause();
            // Allow autoplay when the video enters the viewport again.
            videoState.manuallyPaused = false;
          }
        });
      },
      { threshold: MOBILE_VIEWPORT_THRESHOLD }
    );

    return mobileObserver;
  }

  function syncMobileObserver(video) {
    if (!video) return;

    if (isMobileViewport()) {
      ensureMobileObserver().observe(video);
      return;
    }

    if (mobileObserver) {
      mobileObserver.unobserve(video);
    }
  }

  function syncVideoMode(video) {
    if (isMobileViewport()) {
      video.controls = false;
      video.removeAttribute('controls');
      video.autoplay = false;
      video.removeAttribute('autoplay');
      syncMobileObserver(video);
      return;
    }

    syncMobileObserver(video);
    video.controls = false;
    video.removeAttribute('controls');
    video.autoplay = true;
    video.setAttribute('autoplay', 'autoplay');
    playVideo(video);
  }

  function bindVideo(video) {
    if (state.has(video)) return;

    const onClick = function() {
      if (isMobileViewport()) {
        if (video.paused) {
          playVideo(video);
          const videoState = state.get(video);
          if (videoState) {
            videoState.manuallyPaused = false;
          }
        } else {
          video.pause();
          const videoState = state.get(video);
          if (videoState) {
            videoState.manuallyPaused = true;
          }
        }
      } else {
        if (video.paused) {
          playVideo(video);
        } else {
          video.pause();
        }
      }
    };

    var onVolumeChange = function() { video.muted = true; };
    video.muted = true;
    video.addEventListener('click', onClick);
    video.addEventListener('volumechange', onVolumeChange);
    state.set(video, { onClick: onClick, onVolumeChange: onVolumeChange, manuallyPaused: false });
    syncVideoMode(video);
  }

  function unbindVideo(video) {
    const videoState = state.get(video);
    if (!videoState) return;

    video.removeEventListener('click', videoState.onClick);
    video.removeEventListener('volumechange', videoState.onVolumeChange);
    if (mobileObserver) {
      mobileObserver.unobserve(video);
    }
    state.delete(video);
  }

  function initSection(section) {
    if (!section) return;
    section.querySelectorAll('.ctr-listicle__item-video').forEach(bindVideo);
  }

  function destroySection(section) {
    if (!section) return;
    section.querySelectorAll('.ctr-listicle__item-video').forEach(unbindVideo);
  }

  function syncAllListicleVideos() {
    document.querySelectorAll('.ctr-listicle .ctr-listicle__item-video').forEach(syncVideoMode);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.ctr-listicle').forEach(initSection);
    });
  } else {
    document.querySelectorAll('.ctr-listicle').forEach(initSection);
  }

  window.addEventListener('resize', syncAllListicleVideos);

  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('.ctr-listicle') || event.target.closest('.ctr-listicle');
    initSection(section);
  });

  document.addEventListener('shopify:section:unload', function(event) {
    const section = event.target.querySelector('.ctr-listicle') || event.target.closest('.ctr-listicle');
    destroySection(section);
  });
})();
